import {
  CustomPriceListSortOption,
  OperationType,
} from '@rematter/frontend-lib-api-client';

import { CustomPriceListRecord } from '../types/pricing';

import { createQueryAtomFactory } from '~/shared/providers/api/createQueryAtomFactory';
import { parseZonedDateTime } from '~/shared/utils/dateTime';

export const customPriceListsListQueryAtom = createQueryAtomFactory(
  'brokerage.customPriceListsList',
  (params: {
    ids?: string[];
    isPublished?: boolean;
    isArchived?: boolean;
    limit?: number;
    offset?: number;
    sorting?: CustomPriceListSortOption[];
  }) => ({
    customPriceLists: {
      __args: {
        filter: {
          ids: params.ids,
          isPublished: params.isPublished,
          isArchived: params.isArchived,
        },
        sorting: params.sorting,
        pagination: {
          limit: params.limit ?? 50,
          offset: params.offset ?? 0,
        },
      },
      entries: {
        id: true,
        facilityId: true,
        name: true,
        counterpartyGroupId: true,
        currency: true,
        operationType: true,
        pricingMode: true,
        startDate: true,
        endDate: true,
        isPublished: true,
        archivedAt: true,
        notes: true,
        updatedByUser: {
          id: true,
          firstName: true,
          lastName: true,
        },
        timestamps: {
          createdAt: true,
          updatedAt: true,
        },
      },
      page: {
        total: true,
      },
    },
  }),
  {
    select: (
      data,
    ): { customPriceLists: CustomPriceListRecord[]; totalCount: number } => {
      if (!data?.customPriceLists?.entries) {
        return { customPriceLists: [], totalCount: 0 };
      }

      return {
        customPriceLists: data.customPriceLists.entries.map((list) => ({
          id: list.id,
          facilityId: list.facilityId,
          name: list.name,
          counterpartyGroupId: list.counterpartyGroupId,
          currency: list.currency,
          operationType: list.operationType as OperationType,
          pricingMode: list.pricingMode as 'Standard' | 'CRV',
          startDate: list.startDate ? parseZonedDateTime(list.startDate) : null,
          endDate: list.endDate ? parseZonedDateTime(list.endDate) : null,
          isPublished: list.isPublished,
          archivedAt: list.archivedAt
            ? parseZonedDateTime(list.archivedAt)
            : null,
          notes: list.notes ?? null,
          updatedByUser: list.updatedByUser
            ? {
                id: list.updatedByUser.id,
                name: `${list.updatedByUser.firstName} ${list.updatedByUser.lastName}`.trim(),
              }
            : null,
          timestamps: {
            createdAt: parseZonedDateTime(list.timestamps.createdAt),
            updatedAt: parseZonedDateTime(list.timestamps.updatedAt),
          },
        })),
        totalCount: data.customPriceLists.page?.total ?? 0,
      };
    },
  },
);
